export enum BusinessCaseType {
  Anfangsbestand = 0,
  Umsatz = 1,
  Pfand = 2,
  PfandRueckzahlung = 3,
  MehrzweckgutscheinKauf = 4,
  MehrzweckgutscheinEinloesung = 5,
  EinzweckgutscheinKauf = 6,
  EinzweckgutscheinEinloesung = 7,
  Forderungsentstehung = 8,
  Forderungsaufloesung = 9,
  Anzahlungseinstellung = 10,
  Anzahlungsaufloesung = 11,
  Privateinlage = 12,
  Privatentnahme = 13,
  Geldtransit = 14,
  DifferenzSollIst = 15,
  TrinkgeldAG = 16,
  TrinkgeldAN = 17,
  Auszahlung = 18,
  Einzahlung = 19,
  Rabatt = 20,
  Aufschlag = 21,
  Lohnzahlung = 22,
  ZuschussEcht = 23,
  ZuschussUnecht = 24
}

export const BusinessCaseTypeLabels: { [key: number]: string } = {
  [BusinessCaseType.Anfangsbestand]: "Anfangsbestand",
  [BusinessCaseType.Umsatz]: "Umsatz",
  [BusinessCaseType.Pfand]: "Pfand",
  [BusinessCaseType.PfandRueckzahlung]: "Pfand Rückzahlung",
  [BusinessCaseType.MehrzweckgutscheinKauf]: "Mehrzweckgutschein Kauf",
  [BusinessCaseType.MehrzweckgutscheinEinloesung]: "Mehrzweckgutschein Einlösung",
  [BusinessCaseType.EinzweckgutscheinKauf]: "Einzweckgutschein Kauf",
  [BusinessCaseType.EinzweckgutscheinEinloesung]: "Einzweckgutschein Einlösung",
  [BusinessCaseType.Forderungsentstehung]: "Forderungsentstehung",
  [BusinessCaseType.Forderungsaufloesung]: "Forderungsaufloesung",
  [BusinessCaseType.Anzahlungseinstellung]: "Anzahlungseinstellung",
  [BusinessCaseType.Anzahlungsaufloesung]: "Anzahlungsaufloesung",
  [BusinessCaseType.Privateinlage]: "Privateinlage",
  [BusinessCaseType.Privatentnahme]: "Privatentnahme",
  [BusinessCaseType.Geldtransit]: "Geldtransit",
  [BusinessCaseType.DifferenzSollIst]: "Differenz Soll/Ist",
  [BusinessCaseType.TrinkgeldAG]: "Trinkgeld AG",
  [BusinessCaseType.TrinkgeldAN]: "Trinkgeld AN",
  [BusinessCaseType.Auszahlung]: "Auszahlung",
  [BusinessCaseType.Einzahlung]: "Einzahlung",
  [BusinessCaseType.Rabatt]: "Rabatt",
  [BusinessCaseType.Aufschlag]: "Aufschlag",
  [BusinessCaseType.Lohnzahlung]: "Lohnzahlung",
  [BusinessCaseType.ZuschussEcht]: "Zuschuss Echt",
  [BusinessCaseType.ZuschussUnecht]: "Zuschuss Unecht"
};
